/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { registerField } from 'core/forms';

import DatePicker from '../../exceed/components/datePicker';

const FormFieldDate = ({
  fieldId,
  schema = {
    clearButtonText: '',
    doneButtonText: '',
    inputType: 'button',
    isDisabled: false,
    placeholder: '',
    verticalPosition: 'bottom',
  },
  updateField,
  value = '',
}) => (
  <DatePicker
    id={fieldId}
    value={value}
    onChange={updateField}
    {...schema}
  />
);

FormFieldDate.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.string,
  schema: PropTypes.shape({
    placeholder: PropTypes.string,
    isDisabled: PropTypes.bool,
    clearButtonText: PropTypes.string,
    doneButtonText: PropTypes.string,
    inputType: PropTypes.oneOf(['button', 'text']),
    verticalPosition: PropTypes.oneOf(['auto', 'top', 'bottom']),
  }),
};

registerField('Date', React.memo(FormFieldDate));

export default FormFieldDate;
